module.exports = {
  OperationFailed: 'Thao tác thất bại',
  SelectTime: 'Chọn thời gian',
  FeeRefund: '(Có phí hoàn hải quan)',
  TheHasExpiredNoCreated: 'Hợp đồng của đơn vị ủy thác đã hết hạn, không thể tạo nghiệp vụ mới',
  DueCannotBePrintedNeeded: 'Do vượt hạn mức tín dụng, vận đơn đã bị khóa, không thể in hoặc gửi EDI. Vui lòng liên hệ cấp trên để mở khóa khi cần!',
  ItPrintedPleaseContactUnlock: 'Đã bị khóa, không thể in. Vui lòng liên hệ quản lý cấp trên để mở khóa!',
  AttachmentContentIsTooLarge: 'Nội dung tệp đính kèm quá lớn',
  Unknown: 'Không rõ',
  YourWeightAndVolumeTo: 'Hàng hóa của bạn đã tham gia đối chiếu dữ liệu, hệ thống tự động đóng kiện sẽ cập nhật thông tin số kiện/trọng lượng/thể tích cho vận đơn này và vận đơn chính liên quan.',
  Tip: 'Thông báo',
  GotIt: 'Đã hiểu',
  AddNew: 'Thêm mới',
  PleaseSelectTheSpecifiedData: 'Vui lòng chọn dữ liệu chỉ định',
  LicenseOfLadingNumberEmpty: 'Biển số xe và số vận đơn không được để trống',
  IntegratedLogisticsCargoDetails: 'Chi tiết hàng hóa logistics tổng hợp',
  PleaseAPieceOfData: 'Vui lòng chọn một bản ghi!',
  Mbl: 'Số CMR'
}
